import { render, staticRenderFns } from "./active-token.vue?vue&type=template&id=6df4b1e6&scoped=true"
import script from "./active-token.vue?vue&type=script&lang=js"
export * from "./active-token.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df4b1e6",
  null
  
)

export default component.exports